var theHtml;

theHtml = $('html');

$(function() {
  $('.lt-ie10 #coupons-search input.input-small').on('click', function(e) {
    return $('#coupons-search input[type=search]').val('');
  });
  $('.lt-ie10 .subscribe-email').on('click', function(e) {
    return $('.subscribe-email').val('');
  });
  if (theHtml.hasClass('lt-ie10')) {
    Coupons.clonePlaceholderText('#coupons-search input.input-small');
    Coupons.clonePlaceholderText('.subscribe-email');
  }
  if (theHtml.hasClass('lt-ie8')) {
    return $('.should-truncate').removeClass('should-truncate');
  }
});

